<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('safe.language') }}
      </div>
    </div>
    <div class="wrap_box">
      <div
        class="item"
        @click="changeLang('en_us',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/en_us.png"></div>
          <div class="info">
            English
          </div>
        </div>
        <div v-if="lang=='en_us'">
          ✓
        </div>
      </div>
	  <div
	    class="item"
	    @click="changeLang('tr_tr',$event)"
	  >
	    <div class="left flex_center">
	      <div><img src="../images/language/tr_tr.png"></div>
	      <div class="info">
	        Türkçe
	      </div>
	    </div>
	    <div v-if="lang=='tr_tr'">
	      ✓
	    </div>
	  </div>
	  <div
	    class="item"
	    @click="changeLang('en_ca',$event)"
	  >
	    <div class="left flex_center">
	      <div><img src="../images/language/en_ca.png"></div>
	      <div class="info">
	        Canada
	      </div>
	    </div>
	    <div v-if="lang=='en_ca'">
	      ✓
	    </div>
	  </div>
	  <div
	    class="item"
	    @click="changeLang('en_en',$event)"
	  >
	    <div class="left flex_center">
	      <div><img src="../images/language/en_en.png"></div>
	      <div class="info">
	        United Kingdom
	      </div>
	    </div>
	    <div v-if="lang=='en_en'">
	      ✓
	    </div>
	  </div>
	  <div
	    class="item"
	    @click="changeLang('zh_hk',$event)"
	  >
	    <div class="left flex_center">
	      <div><img src="../images/language/es_spa.png"></div>
	      <div class="info">
	        Español
	      </div>
	    </div>
	    <div v-if="lang=='zh_hk'">
	      ✓
	    </div>
	  </div>
	  <div
	    class="item"
	    @click="changeLang('pt_br',$event)"
	  >
	    <div class="left flex_center">
	      <div><img src="../images/language/pt_br.png"></div>
	      <div class="info">
	        Brasil
	      </div>
	    </div>
	    <div v-if="lang=='pt_br'">
	      ✓
	    </div>
	  </div>
      <div
        class="item"
        @click="changeLang('id_ind',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/id_ind.png"></div>
          <div class="info">
            Indonesia
          </div>
        </div>
        <div v-if="lang=='id_ind'">
          ✓
        </div>
      </div>
  <div
    class="item"
    @click="changeLang('fr_fr',$event)"
  >
    <div class="left flex_center">
      <div><img src="../images/language/fr_fr.png"></div>
      <div class="info">
        France
      </div>
    </div>
    <div v-if="lang=='fr_fr'">
      ✓
    </div>
  </div>
      <div
        class="item"
        @click="changeLang('th_th',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/th_th.png"></div>
          <div class="info">
            ภาษาไทย
          </div>
        </div>
        <div v-if="lang=='th_th'">
          ✓
        </div>
      </div>
      <div
        class="item"
        @click="changeLang('vi_vn',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/vi_vn.png"></div>
          <div class="info">
            Người việt nam
          </div>
        </div>
        <div v-if="lang=='vi_vn'">
          ✓
        </div>
      </div>
      <div
        class="item"
        @click="changeLang('ja_jp',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/ja_jp.png"></div>
          <div class="info">
            日本語
          </div>
        </div>
        <div v-if="lang=='ja_jp'">
          ✓
        </div>
      </div>
      <div
        class="item"
        @click="changeLang('ko_kr',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/ko_kr.png"></div>
          <div class="info">
            한국어
          </div>
        </div>
        <div v-if="lang=='ko_kr'">
          ✓
        </div>
      </div>
      <div
        class="item"
        @click="changeLang('ms_my',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/ms_my.png"></div>
          <div class="info">
            Melayu
          </div>
        </div>
        <div v-if="lang=='ms_my'">
          ✓
        </div>
      </div>
 
<!--      <div
        class="item"
        @click="changeLang('zh_cn',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/zh_cn.png"></div>
          <div class="info">
            简体中文
          </div>
        </div>
        <div v-if="lang=='zh_cn'">
          ✓
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
	import Fetch from '../../utils/fetch'
	import bsHeader from '../../components/bsHeader.vue'
	import {
		Toast
	} from 'vant'
	export default {
		name: "Language",
		components: {
			bsHeader
		},
		data() {
			return {
				lang:this.$i18n.locale||"en_us",
			};
		},
		created() {
		},
		mounted() {
		},
		methods: {
			changeLang(lang,event) {
				Toast.loading({
					// mask: true,
					duration: 200
				})
				this.lang = lang;
				this.$i18n.locale = lang;
				localStorage.setItem("lang", lang);
				this.$router.go(-1);
			},
		}
	};
</script>

<style lang="less" scoped>
	// .red_top_bg {
	// 	// background: linear-gradient(90deg, #5b60df, #5b60df) !important;
	// }
	.wrap_box{
		display: flex;
		flex-direction: column;
		align-items: center;
		border-radius: 5px;
		width: 98%;
		margin: 5px auto;
		.item{
			height: 50px;
			width: 95%;
			padding: 16px 0;
			border-bottom: 1px solid #ECECEC;
			font-size: 14px;
			color: rgba(0,0,0,.8);
			font-weight: bold;
			line-height: 20px;
			display: flex;
			justify-content: space-between;
			.right{
				width: 20px;
				height: 20px;
				background: url(../images/user/arrow.png) no-repeat center center;
				background-size: 100% 100%;
			}
			.right_info{
				color: rgba(0,0,0,.6);
			}
			.tips{
				color: rgba(0,0,0,.6);
				margin-left: auto;
				margin-right: 4px;
				font-weight: normal;
			}
			.left{
				img{
					width: 33px;
					margin-top: 5px;
				}
			}
		}
	}

	/* Tawkify ink-teal selector styling. */
	.basic_wrap { min-height: 100vh; padding-bottom: calc(86px + env(safe-area-inset-bottom)); background: linear-gradient(180deg, #f8fcfb, #edf7f5); }.red_top_bg { height: 54px; background: rgba(248, 252, 251, .97); border-bottom: 1px solid #b9dcd8; }.red_top_bg .big_tit, .red_top_bg .back_left { color: #073f47; }
	.wrap_box { width: auto; margin: 14px; padding: 0 14px; border: 1px solid #b9dcd8; border-radius: 15px; background: rgba(255, 255, 255, .96); box-shadow: 0 10px 22px rgba(7, 72, 78, .08); }.wrap_box .item { width: 100%; height: 58px; padding: 0; align-items: center; border-bottom-color: #d9ebe8; color: #1c454a; }.wrap_box .item:last-child { border-bottom: 0; }.wrap_box .item .left { gap: 11px; }.wrap_box .item .left img { width: 31px; margin-top: 0; border-radius: 50%; box-shadow: 0 0 0 1px #a9d3cf; }.wrap_box .item .left .info { font-size: 14px; font-weight: 500; line-height: 20px; }.wrap_box .item>div:last-child { display: flex; height: 100%; align-items: center; color: #087b84; font-size: 20px; }
</style>
